var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.291,
    height: 36.291,
    viewBox: "0 0 36.291 36.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "send",
    transform: "translate(-4466.057 -2239.506)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 18.145,
    cy: 18.145,
    r: 18.145,
    transform: "translate(4466.057 2239.506)",
    fill: "#e05e6b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M4472.47,2250.569l8.917,7.643v13.932l15.285-21.574Z",
    fill: "#fff",
    stroke: "#e05e6b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.056
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_45",
    "data-name": "Line 45",
    y1: 7.643,
    x2: 15.285,
    transform: "translate(4481.386 2250.569)",
    fill: "#fff",
    stroke: "#e05e6b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.056
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.f140eef8966be82e1dea26a943a708ff.svg";
export { ForwardRef as ReactComponent };